export default "__VITE_ASSET__bd6a4559__"